import request from "@/utils/http"
import store from "@/store"
import { Message } from "element-ui"
import { cacheRequest } from "@/utils/decorator"

export function getSheetBtns(sheetId) {
  return request.get(`/sheet/btn/getList/${sheetId}`)
}

export function getBtn(btnId) {
  return request.get(`/sheet/btn/get/${btnId}`)
}

export function createBtn(btn) {
  return request.post(`/sheet/btn/create`, btn)
}

export function updateBtn(btn) {
  return request.post("/sheet/btn/update", btn)
}

export function deleteBtn(btnId) {
  return request.get(`/sheet/btn/delete/${btnId}`)
}

/**
 * @param appId 非必填
 * @param btnId
 * @param dataId
 * @returns {AxiosPromise<any>}
 */
export function clickBtn({ appId, btnId, dataId }) {
  return request.get(`/sheet/btn/click`, { params: { appId, btnId, dataId } }).commonDeal()
}

export function clickSheetBtn(param) {
  return request.post(`/sheet/clickSheetBtn`, param).commonDeal()
}

/**
 *
 * @param appId 非必填
 * @param btnId
 * @param dataId
 * @param data
 * @returns {AxiosPromise<any>}
 */
export function fillForm({ appId, btnId, dataId, data }) {
  if (store.getters.isTemplateMode) {
    Message.warning("预览状态无法操作")
    return Promise.reject({ code: 1, msg: "预览状态无法操作" })
  }
  return request
    .post(`/sheet/btn/fillForm`, data, { params: { appId, btnId, dataId } })
    .commonDeal()
}

class SheetBtnApi {
  @cacheRequest()
  getAppBtns(appId, cache) {
    return request.get(`/sheet/btn/getListAll/${appId}`).commonDeal()
  }
}
export const sheetBtnApi = new SheetBtnApi()
